import { AccountProduct } from '@epicuro-next/data/account-products-data';
import { createAction, props } from '@ngrx/store';

import { CustomerProductIdentifierUpdate } from '../models';

export const initModule = createAction(
  '[CustomerProductIdentifiers] Init module',
);

export const loadCustomerProductIdentifiers = createAction(
  '[CustomerProductIdentifiers] Load CustomerProductIdentifiers',
);

export const loadCustomerProductIdentifiersSuccess = createAction(
  '[CustomerProductIdentifiers] Load CustomerProductIdentifiers Success',
  props<{ identifiers: AccountProduct[] }>(),
);

export const loadCustomerProductIdentifiersFailure = createAction(
  '[CustomerProductIdentifiers] Load CustomerProductIdentifiers Failure',
  props<{ error: Error }>(),
);

export const updateCustomerProductIdentifier = createAction(
  '[CustomerProductIdentifiers] Update CustomerProductIdentifiers',
  props<CustomerProductIdentifierUpdate>(),
);

export const updateCustomerProductIdentifierSuccess = createAction(
  '[CustomerProductIdentifiers] Update CustomerProductIdentifiers Success',
);

export const updateCustomerProductIdentifierFailure = createAction(
  '[CustomerProductIdentifiers] Update CustomerProductIdentifiers Failure',
  props<{ error: Error }>(),
);
